import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Sped360Service } from '../../../sped360.service';

@Component({
  selector: 'app-check-in-check-out',
  templateUrl: './check-in-check-out.component.html'
})
export class CheckInCheckOutComponent implements OnInit {
  dialogTitle = '';
  checkedOutBy: string;
  templateName: string;
  collectionCode: string;
  checkOutDocument = false;
  checkOutDocument504 = false;
  constructor(private dialogRef: MatDialogRef<CheckInCheckOutComponent>,
    private sped360Service: Sped360Service) {

  }

  ngOnInit(): void {
    this.checkOutDocument = this.sped360Service.spedFixedPermission.CheckOutDocument;
    this.checkOutDocument504 = this.sped360Service.spedFixedPermission.CheckOut504Document;
  }
  closeClick() {
    this.sped360Service.continueClicked = false;
    this.dialogRef.close();
  }

  saveClick() {
    this.sped360Service.continueClicked = true;
    this.dialogRef.close('save');
  }

}